import { inject, injectable } from 'inversify'
import 'reflect-metadata'
import { TYPES } from '../../../../common/domain/types'

import type { IDataSourceServiceRepository } from '../domain/IDataSourceServiceRepository';

import { IServiceDataSourceService } from './IServiceDataSourceService';
import { IapDataSourceService } from '../domain/iapDataSourceService';
import { IapDataSourceTableAlias } from '../domain/iapDataSourceTableAlias';
import { WSDL } from '../domain/wsdl';
import { Swagger } from '../domain/swagger';





@injectable()
export class DataSourceServiceService implements IServiceDataSourceService {
  private readonly repo: IDataSourceServiceRepository

  public constructor(@inject(TYPES.DATASOURCESERVICE_REPOSITORY) _repo: IDataSourceServiceRepository) {
    this.repo = _repo
  }

  async update(data: IapDataSourceService): (Promise<IapDataSourceService>) {
    return await this.repo.update(data);
  }

  async delete(dataSourceId: number): (Promise<boolean>) {
    return await this.repo.delete(dataSourceId);
  }


  async add(data: IapDataSourceService): (Promise<IapDataSourceService>) {
    return await this.repo.add(data);
  }

  async getById(applicationId: number, applicationVersion: number, datasourceId: number): Promise<IapDataSourceService> {
    return await this.repo.getById(applicationId, applicationVersion, datasourceId)
  }

  async classFromWsdlUrl(applicationId: number, applicationVersion: number, datasourceId: number, url: string): Promise<WSDL> {
    return await this.repo.classFromWsdlUrl(applicationId, applicationVersion, datasourceId, url)
  }

  async classFromSwaggerUrl(applicationId: number, applicationVersion: number, datasourceId: number, url: string): Promise<Swagger> {
    return await this.repo.classFromSwaggerUrl(applicationId, applicationVersion, datasourceId, url)
  }

  async callWebServiceSOAP(applicationId: number, applicationVersion: number, datasourceId: number, url: string, method: string, request: string): Promise<string> {
    return await this.repo.callWebServiceSOAP(applicationId, applicationVersion, datasourceId, url, method, request)
  }
}